import styled from 'styled-components';

export const MetricReportsFilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 5px;
  padding: 15px 10px;

  @media screen and (max-width: 576px) {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }
`;

export const FilterInnerContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-right: auto;
    gap: 16px;
}

  @media screen and (max-width: 576px) {
    flex-direction: column;

    > div {
      margin: 0;
      margin-bottom: 15px;
      max-width: 100%;
    }
  }

  .filter {
    min-width: 120px;
    max-width: 280px;

    &.filter-metric {
      min-width: 200px;
    }

    @media screen and (max-width: 576px) {
      min-width: unset;
      max-width: unset;
      width: 100%;
    }
  }
`;
